import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { useBasket } from '@view/view_create_new_message/hooks/use-basket';
import { useResolve } from '@visiba/instantiation';
import { useCallback, useEffect } from 'react';
import { CreateNewMessageAnalyticActions, useCreateNewMessage } from '../../hooks/use-create-new-message';
import { useSaveParticipants } from './use-save-participants';

interface PresentationModel {
	access: string[];
}

interface FormData {
	access: string[];
}

export function useAccess() {
	const { flowSettings, goToScreen, updateFlowSettings } = useCreateNewMessage();
	const { basket } = useBasket();
	const analyticService = useResolve(AnalyticService);
	const { access, save } = useSaveParticipants();

	const data: PresentationModel = { access };

	useEffect(() => {
		analyticService.trackPageView({
			customTitle: 'Create new message: Who has access',
		});
	}, [analyticService]);

	useEffect(() => {
		if (flowSettings.flowState !== 'accessible' || basket == null) {
			return;
		}

		// No participants means there is nothing to manage access for; skip the step.
		if (basket.Participants.length === 0) {
			analyticService.trackEvent(AnalyticCategories.CreateNewMessage, CreateNewMessageAnalyticActions.DoesNotUseRepresentatives);
			updateFlowSettings({ access: [] });
			goToScreen('conclusion', { replace: true });
		}
	}, [analyticService, basket, flowSettings.flowState, goToScreen, updateFlowSettings]);

	const submit = useCallback(
		async (data: FormData) => {
			await save({ access: data.access });
			goToScreen('conclusion');
		},
		[goToScreen, save],
	);

	return { data, submit };
}
